/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Auth from "../../shared/Auth";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import './Dashboard.css';
import Globals from "../../shared/Globals";
import WoundTypeBreakdownChart from "../chart/WoundTypeBreakdownChart";
import { CardPrimary } from "./NewDashboard";
import WorkorderBreakdownChart from "../chart/project/WorkorderBreakdownChart";
import L from "../Lang";


class GenDashboard extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            user: null
        };
    }

    async componentDidMount() {
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
        await this.getSettings();
    }

    render() {
        return <div className="Dashboard container-fluid">
            <h1>Dashboard</h1>
            <h2>Good <span>{Globals.getTimeOfDay()}</span> {this.state.user?.name}!</h2>

            <div className="row">
                <div className="col-lg-6 mt-3">
                    <CardPrimary title={<L>Work Order Breakdown</L>}>
                        <WorkorderBreakdownChart />
                    </CardPrimary>
                </div>
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(GenDashboard);